import { render, staticRenderFns } from "./TemplateEditor.vue?vue&type=template&id=09ae0922&scoped=true&"
import script from "./TemplateEditor.vue?vue&type=script&lang=ts&"
export * from "./TemplateEditor.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateEditor.vue?vue&type=style&index=0&id=09ae0922&scoped=true&lang=css&"
import style1 from "./TemplateEditor.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ae0922",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCard,VCol,VRow,VSpacer,VTextarea})
